<template>
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10.5001L8 12.5001L12.5 8.00011M17 11.0001C17 15.9086 11.646 19.4785 9.69799 20.615C9.4766 20.7442 9.3659 20.8087 9.20968 20.8422C9.08844 20.8682 8.91156 20.8682 8.79032 20.8422C8.6341 20.8087 8.5234 20.7442 8.30201 20.615C6.35396 19.4785 1 15.9086 1 11.0001V6.21772C1 5.4182 1 5.01845 1.13076 4.67482C1.24627 4.37126 1.43398 4.10039 1.67766 3.88564C1.9535 3.64255 2.3278 3.50219 3.0764 3.22146L8.4382 1.21079C8.6461 1.13283 8.75005 1.09385 8.85698 1.07839C8.95184 1.06469 9.04816 1.06469 9.14302 1.07839C9.24995 1.09385 9.3539 1.13283 9.5618 1.21079L14.9236 3.22146C15.6722 3.50219 16.0465 3.64255 16.3223 3.88564C16.566 4.10039 16.7537 4.37126 16.8692 4.67482C17 5.01845 17 5.4182 17 6.21772V11.0001Z"
      stroke="#557925"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
